import { render, staticRenderFns } from "./PageSplash.vue?vue&type=template&id=53ef9add"
import script from "./PageSplash.vue?vue&type=script&lang=js"
export * from "./PageSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports